import { jwtDecode } from 'jwt-decode';
import { tokenStorage } from '../../utils/encryptedCookie';

const useUserRoles = () => {
  const token = tokenStorage.get();
  
  if (token) {
    try {
      const decoded = jwtDecode(token);
      return decoded.roles || [];
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return [];
    }
  }
  
  return [];
};

export default useUserRoles;